import LTR from "@brand-icons/ploom/profile-customer-service/profile-customer-service-ltr.svg";

import { iconFactory } from "../iconFactory";

export const ProfileCustomerServiceIcon = iconFactory("ProfileCustomerServiceIcon", LTR);
